import React from "react";
import socketio from "socket.io-client";
import { SOCKET_URL } from "../config";

export const socket = socketio.connect(SOCKET_URL, {
  autoConnect: true,
});

export const SocketContext = React.createContext();
